import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { getMoney } from '@hlj/hlj-utils'
import style from './style.module.less'
import {
  getCouponImg,
  getCouponText
} from '@components/LocalMerchant/Decoration/util'
import { COUPON_SCOPE_MEAL } from '@constant'
import cls from 'classnames'

@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const {
      id,
      money_sill,
      value,
      condition_of_get,
      scope,
      decorationStore: { theme }
    } = this.props
    const isScoped = scope == COUPON_SCOPE_MEAL

    return (
      <div
        key={id}
        className={style.item}
        style={{ color: getCouponText(theme) }}
      >
        <img
          style={{
            width: '100%',
            height: '100%'
          }}
          src={getCouponImg(theme)}
        />

        <div className={style.content}>
          {/* 会员优惠券 */}
          {condition_of_get == 2 ? (
            <>
              <p className="text-cut">{getMoney(value)}</p>
              <p style={{ fontSize: 9 }} className="text-cut">
                最多可省
              </p>
            </>
          ) : (
            <>
              <p className={cls(style.price, 'text-cut')}>
                <span className={style.unit}>¥</span>
                <span className={style.price}>{value}</span>
                <span className={style.info}>
                  {isScoped ? '指定套餐可用' : '全场可用'}
                </span>
              </p>
              <p style={{ fontSize: 9 }} className="text-cut">
                <span>{!money_sill ? '无门槛' : `满${money_sill}可用`}</span>
              </p>
            </>
          )}
        </div>

        <div className={style.receive}>
          立即<br />领取
        </div>
      </div>
    )
  }
}
